export const INTERACTIVE_TOOL_NAMES = {
    ui_date_picker: 'date_picker',
    ui_address_input: 'address_input',
    ui_options: 'options'
};
export const INTERACTIVE_TYPE_TO_TOOL_NAME = {
    date_picker: 'ui_date_picker',
    address_input: 'ui_address_input',
    options: 'ui_options'
};
//# sourceMappingURL=chat-types.js.map